import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const SbrSequentialBatchReactor: React.FC = () => {
  return (
    <>
      <PageHeader title="SBR – Sequential Batch Reactor" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-4.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-2.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">SBR – Sequential Batch Reactor</h1>
              
              <h3 className="mb-4">Technology Summary:</h3>
              <p>SBR is a fill-and-draw activated sludge process where all treatment steps — aeration, settling, and decanting — occur in the same tank sequentially, reducing footprint and energy usage.</p>

              <h3 className="mb-4">Applications:</h3>
              <p><i className="fa fa-city text-primary me-2"></i>Municipal STPs</p>
              <p><i className="fa fa-industry text-primary me-2"></i>Medium-to-large industries</p>
              <p><i className="fa fa-building text-primary me-2"></i>Smart cities and urban developments</p>

              <h3 className="mb-4">Key Features & Benefits:</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>No need for separate clarifier and aeration tanks</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Fully automated cycle-based control</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Flexible operation for varying load conditions</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Cost-effective for larger capacities</p>

              <hr className="my-5" />

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Technology-neutral design: We suggest MBBR, MBR, or SBR based on your specific site needs.</p>
              <p><i className="fa fa-star text-warning me-2"></i>More than 50 STP installations and operations across India — from 1 KLD to 50 MLD.</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house engineering, electrical, and automation teams.</p>
              <p><i className="fa fa-star text-warning me-2"></i>Comprehensive AMC, O&M, and remote troubleshooting support.</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Dedicated Team for on-site troubleshooting in O&Ms</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default SbrSequentialBatchReactor;
